import gql from 'graphql-tag';

export const typeDefs = gql`
  type Pagination {
    perPage: Int!
    page: Int!
    total: Int!
    order: String!
    sort: Sort!
  }

  type Exam {
    id: ID!
    institution: String!
    role: String!
    jury: String!
    year: Int!
    number: Int!
    complement: String!
    scholarity: String!
    remuneration: Float!
    specificTraining: String!
    passingScore: Int!
    openSpaces: Int!
    candidatesNumber: Int!
    acceptedCandidatesNumber: Int!
    area: String!
    answersType: String!
    active: Boolean!
    pdfUrl: String!
    degreeExam: Boolean!
    questionsNumber: Int!
    createdAt: Date!
    updatedAt: Date!
  }
`;
